import {IconEnglish, IconFrench, IconSpanish} from '../../buttons/IconButtons';


export const MODEL_LANGUAGE = {
    SP: {
        transMd: 'ES',
        trans: 'spanish',
        code: 'sp',
        Icon: IconSpanish,
    },
    EN: {
        transMd: 'EN',
        trans: 'english',
        code: 'en',
        Icon: IconEnglish,
    },
    FR: {
        transMd: 'FR',
        trans: 'french',
        code: 'fr',
        Icon: IconFrench,
    }
}
